import { createTheme } from "@mui/material/styles";

// Layout heights root -> navbar / content
const rootHeight = "100vh";
const appNavBarHeight = "4.5rem";

// Extend module '@mui/material/styles' to add new properties
declare module "@mui/material/styles" {
  interface Theme {
    customTransitions: {
      colorTransition: string;
    };
    customLayoutHeight: {
      rootHeight: string;
      appNavBarHeight: string;
    };
  }
  interface Palette {
    customColors: {
      positiveVariationColor: string;
      negativeVariationColor: string;
      selectorsBarColor: string;
      navBarActiveColor: string;
      dotInactiveColor: string;
    };
  }
  // to work in sync with `createTheme`
  interface ThemeOptions {
    customTransitions?: {
      colorTransition?: string;
    };
    customLayoutHeight?: {
      rootHeight?: string;
      appNavBarHeight?: string;
    };
  }
  interface PaletteOptions {
    customColors?: {
      positiveVariationColor?: string;
      negativeVariationColor?: string;
      selectorsBarColor?: string;
      navBarActiveColor?: string;
      dotInactiveColor?: string;
    };
  }
}

const BaseTheme = createTheme({
  typography: {
    fontFamily:
      '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h1: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 700
    },
    h2: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 700
    },
    h3: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 600
    },
    h4: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 600
    },
    h5: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 600
    },
    h6: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 600
    },
    subtitle1: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 500
    },
    subtitle2: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 500
    },
    body1: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 400
    },
    body2: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 400
    },
    button: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 500
    },
    caption: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 400
    },
    overline: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 400
    }
  },
  palette: {
    primary: {
      main: "#2645F5"
    },
    info: {
      main: "#2645F5"
    },
    secondary: {
      main: "#fa6375",
      contrastText: "#ffffff"
    },
    background: {
      default: "#f7f7f7"
    },
    error: {
      main: "#ff0004"
    },
    customColors: {
      positiveVariationColor: "#00D56F",
      negativeVariationColor: "#FF4500",
      selectorsBarColor: "#eaecf0",
      navBarActiveColor: "#ffffff1a",
      dotInactiveColor: "#e5e7eb"
    }
  },
  shape: {
    borderRadius: 5
  },
  customTransitions: {
    colorTransition: "all 150ms ease-in-out"
  },
  customLayoutHeight: {
    rootHeight: rootHeight,
    appNavBarHeight: appNavBarHeight
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: '"Manrope", sans-serif',
          fontWeight: 500
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: '"Manrope", sans-serif',
          fontWeight: 600
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontFamily: '"Manrope", sans-serif',
          fontWeight: 600
        },
        body: {
          fontFamily: '"Manrope", sans-serif',
          fontWeight: 400
        }
      }
    }
  }
});

export default BaseTheme;
